<div class="container" fxLayout="column" fxFill fxLayoutAlign="space-between center">
  <h2 fxLayout="row" fxLayoutAlign="center" mat-dialog-title i18n="trial-dialog|Warning; trial phase exceeded@@trial-dialog_warning_trial-exceeded">Your 30-days trial phase has exceeded</h2>
  <mat-dialog-content fxLayout="row" fxLayoutAlign="center" i18n="trial-dialog|Info; contact sales team@@trial-dialog_info_contact-sales-team">
    If you want to continue using Apollo, please get in touch with our sales team
  </mat-dialog-content>
  <mat-dialog-actions fxLayout="row" fxLayoutAlign="center">
    <a href="mailto:support@apollo.ai" target="_blank" mat-flat-button color="primary" i18n="trial-dialog|Button; contact sales@@trial-dialog_button_contact-sales">Contact Sales</a>
  </mat-dialog-actions>
</div>
